import { z } from 'zod';

/**
 * Default triage prompt (pt-BR). Mirrors the `TRIAGE_PROMPT_DEFAULT`
 * from the design handoff (`triagem-config.source.jsx`). Seeded per org
 * by `ensureDefaultTriageConfig` and offered as the baseline in the UI.
 *
 * Rules address squads by their `squad.code` (stable key) and always
 * end with an explicit fallback so an unmatched card stays in the
 * manual triage box.
 */
export const TRIAGE_PROMPT_DEFAULT = `Direcione cada card novo para o squad correto a partir do conteúdo da conversa.
Use SEMPRE o código do squad (squad.code) ao definir o destino.

- Voo, hotel, remarcação, reserva ou check-in  ->  VOOS_HOTEIS
- Cliente VIP, executivo ou conta corporativa   ->  VIP_EXECUTIVOS
- Reclamação, insatisfação explícita ou tom frustrado  ->  RECLAMACOES
- Reembolso, estorno ou cancelamento com devolução  ->  REEMBOLSOS
- Cobrança, cartão ou problema de pagamento  ->  PAGAMENTOS
- Nota fiscal, fatura ou faturamento  ->  FATURAMENTO

Se nenhuma regra se aplicar, mantenha o card na caixa de triagem para classificação manual.`;

/** Upper bound for the prompt — generous room for many squad rules. */
export const TRIAGE_PROMPT_MAX_LENGTH = 8000;

/**
 * Per-tenant triage configuration. When `enabled`, a newly created card
 * with no squad is routed automatically by an LLM that reads the card
 * and follows `prompt` (natural-language rules citing `squad.code`).
 *
 * Mirrors the board-config pattern: this is the domain shape; the kanban
 * document extends it with `_schemaVersion` / `orgId` / `_v`, and the
 * wire response echoes `_v` for optimistic locking.
 */
export const TriageConfigSchema = z.object({
  enabled: z.boolean(),
  prompt: z.string().min(1).max(TRIAGE_PROMPT_MAX_LENGTH),
  updatedAt: z.coerce.date(),
  updatedByUserId: z.string().min(1).max(200),
});

export type TriageConfig = z.infer<typeof TriageConfigSchema>;
